import type { FC } from 'react';
import styled from 'styled-components';
import {
  AppAudioPlayerAmazonMusicMulticolor,
  AppAudioPlayerAppleMusicMulticolor,
  AppAudioPlayerButtonsApplePodcast,
  AppAudioPlayerButtonsCastbox,
  AppAudioPlayerButtonsCastro,
  AppAudioPlayerButtonsGooglePodcast,
  AppAudioPlayerButtonsOvercast,
  AppAudioPlayerButtonsPocketCasts,
  AppAudioPlayerButtonsRss,
  AppAudioPlayerButtonsSoundcloud,
  AppAudioPlayerButtonsSpotify,
  AppAudioPlayerButtonsStitcher,
  AppAudioPlayerDisc,
  AppAudioPlayerDownloadCloud,
  AppAudioPlayerDownloadTrack24,
  AppAudioPlayerGooglePlayMulticolor,
  AppAudioPlayerHeadphones,
  AppAudioPlayerItunesMulticolor,
  AppAudioPlayerMicro,
  AppAudioPlayerMusical,
  AppAudioPlayerShoppingBag
} from '@elfsight/icons';
import type { PropsWithClassName } from '../../../types';

interface IconProps extends PropsWithClassName {
  name?: string;
}

const icons: Record<string, FC> = {
  album: AppAudioPlayerDisc,
  amazon: AppAudioPlayerAmazonMusicMulticolor,
  appleMusic: AppAudioPlayerAppleMusicMulticolor,
  buy: AppAudioPlayerShoppingBag,
  download: AppAudioPlayerDownloadTrack24,
  downloadCloud: AppAudioPlayerDownloadCloud,
  googlePlay: AppAudioPlayerGooglePlayMulticolor,
  headphones: AppAudioPlayerHeadphones,
  itunes: AppAudioPlayerItunesMulticolor,
  microphone: AppAudioPlayerMicro,
  song: AppAudioPlayerMusical,

  rss: AppAudioPlayerButtonsRss,
  overcast: AppAudioPlayerButtonsOvercast,
  stitcher: AppAudioPlayerButtonsStitcher,
  castbox: AppAudioPlayerButtonsCastbox,
  spotify: AppAudioPlayerButtonsSpotify,
  googlePodcast: AppAudioPlayerButtonsGooglePodcast,
  pocketCasts: AppAudioPlayerButtonsPocketCasts,
  soundcloud: AppAudioPlayerButtonsSoundcloud,
  applePodcast: AppAudioPlayerButtonsApplePodcast,
  castro: AppAudioPlayerButtonsCastro
};

export function Icon({ name = 'download', className }: IconProps) {
  if (!(name in icons)) {
    return null;
  }

  return <IconComponent as={icons[name]} className={className} />;
}

export const IconComponent = styled.svg``;
